import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { Button } from 'stories/components'
import { formatEmailArray, formatTime } from 'utils'

import { EmailLog } from './type'

interface EmailLogDetailProps {
  log: EmailLog
  onBack: () => void
}

export const EmailLogDetail = ({ log, onBack }: EmailLogDetailProps) => {
  return (
    <div className="mt-4">
      <Button link onClick={onBack}>
        <div className="flex text-shade-blue items-center">
          <ArrowLeftIcon className="w-4 h-4 mr-1" /> <p>Return to Email Logs</p>
        </div>
      </Button>
      <div className="space-y-4 mt-4">
        <div className="flex justify-between items-start mb-4 gap-6">
          <h1 className="text-lg font-bold text-gray-900">{log.subject}</h1>
          <span className="text-sm text-gray-500">{formatTime(log.createdAt, 'MM/dd/yyyy HH:mm:ss')}</span>
        </div>
        <div className="flex items-center gap-1 text-sm text-gray-700">
          <span className="font-semibold">To:</span>
          <span>{formatEmailArray(log.to)}</span>
        </div>
        {log?.cc && log.cc.length > 0 && (
          <div className="flex items-center gap-1 text-sm text-gray-700">
            <span className="font-semibold">CC:</span>
            <span>{formatEmailArray(log.cc)}</span>
          </div>
        )}
        {log?.bcc && log.bcc.length > 0 && (
          <div className="flex items-center gap-1 text-sm text-gray-700">
            <span className="font-semibold">BCC:</span>
            <span>{formatEmailArray(log.bcc)}</span>
          </div>
        )}
        {log?.replyTo && log.replyTo.length > 0 && (
          <div className="flex items-center gap-1 text-sm text-gray-700">
            <span className="font-semibold">Reply To:</span>
            <span>{log.replyTo}</span>
          </div>
        )}
        <hr className="my-4 border-gray-300" />
        <div className="mt-4 overflow-y-auto" dangerouslySetInnerHTML={{ __html: log.content }} />
        {log?.attachments && log.attachments.length > 0 && (
          <>
            <hr className="my-4 border-gray-300" />
            <div className="text-sm text-gray-700 flex flex-wrap gap-x-1">
              {log.attachments.map((attachment: any, index: number) => (
                <span key={index}>
                  {attachment.filename} ({(attachment.size / 1024).toFixed(2)} KB)
                  {index < (log.attachments?.length || 0) - 1 && ','}
                </span>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
